define.alias("shared/components/shared/media/filter/filter-media-type", "calendar/components/shared/media/filter/filter-media-type");